// extracted by mini-css-extract-plugin
module.exports = {"time":"styles_time__qKCfn","refresh":"styles_refresh__3brmq"};